export class BrowserHelper {
  public checkBrowser() {
    const userAgent = window.navigator.userAgent.toLowerCase();
    const isChrome = userAgent.indexOf('chrome');
    // const isSafari = userAgent.indexOf('safari');
    // const isEdge = userAgent.indexOf('edge');

    if (isChrome > -1) return true;

    return false;
  }

  public checkChromeBrowser(): boolean {
    return (
      navigator.userAgent.includes('Chrome') ||
      navigator.userAgent.includes('chrome')
    );
  }

  public async getBrowserPermissionState(
    name: PermissionName,
  ): Promise<PermissionStatus> {
    return window.navigator.permissions.query({ name });
  }

  public async getBrowserMedia(
    constraints?: MediaStreamConstraints,
  ): Promise<MediaStream> {
    return window.navigator.mediaDevices.getUserMedia(constraints);
  }
}
